/*
This file is located in the main branch
Last time the file was updated (UTC): [06.12.2023 15:23:18]
Permissions to update outside the main branch: [false]
*/

import useAuth from 'hooks/useAuth';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

const LoginRedirect = () => {
    const { auth } = useAuth();
    const location = useLocation();

    return auth?.user ? <Outlet /> : <Navigate to={'/login'} state={{ from: location }} replace />;
};

export default LoginRedirect;
